module.exports = __webpack_public_path__ + "static/media/logo-dev.289fe23b.webp";